import { render } from "./TDFormCar.vue?vue&type=template&id=027f528b"
import script from "./TDFormCar.vue?vue&type=script&lang=js"
export * from "./TDFormCar.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__